import { Table, Tbody, Thead } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { TableHeader } from './TableHeader';
import { TableRow } from './TableRow';

export interface TableColumns<T> {
  key: string;
  title: string;
  width?: number;
  fontSize?: string;
  color?: string;
  render?: (column: TableColumns<T>, item: T) => void;
}

interface Props<T> {
  data: T[];
  columns: TableColumns<T>[];
  extra?: ReactNode;
}
export function ListTable<T>({ data, columns, extra }: Props<T>): JSX.Element {
  return (
    <>
      <Table variant="simple">
        <Thead>
          <TableHeader columns={columns} />
        </Thead>
        <Tbody>
          <TableRow data={data} columns={columns} />
        </Tbody>
      </Table>
      {extra}
    </>
  );
}
